// 4 section for checking the symptoms

import React from 'react';
import data from '../../femcare-content.json';

const { symptomChecker } = data.sections;

const SymptomChecker = () => {
  const {
    id,
    headingLine1,
    headingLine2,
    descriptionPrimary,
    descriptionSecondary,
    cta,
    image,
  } = symptomChecker;

  return (
    <section id={id} className="w-full bg-white overflow-hidden">
      {/* <div className="container mx-auto px-6 md:px-12 lg:px-16"> */}
        <div className="relative flex flex-col lg:flex-row items-center min-h-[420px]">

          {/* ── Left: Text Content ── */}
          <div className="w-full lg:w-3/5 flex flex-col justify-center px-6 md:px-12 lg:pl-10 lg:pr-12 py-12 order-2 lg:order-1">

            {/* Heading */}
            <h2
              className="ava-heading-lg mb-5"
              style={{
                // color: 'var(--primary-color)',
                // fontSize: 'clamp(1.4rem, 2.8vw, 2rem)',
              }}
            >
              {headingLine1}
              <br />
              {headingLine2}
            </h2>

            {/* Description paragraphs */}
            <p
              className="ava-text-body mb-4"
              style={{ 
                // color: 'var(--text-light)',
                 maxWidth: '520px' }}
            >
              {descriptionPrimary}
            </p>

            <p
              className="ava-text-body  mb-8"
              style={{ 
                // color: 'var(--text-light)', 
                maxWidth: '520px' }}
            >
              {descriptionSecondary}
            </p>

            {/* CTA Button */}
            <div>
              <a
                href={cta.href}
                className="btn-primary "
              >
                {cta.label}
              </a>
            </div>
          </div>

          {/* ── Right: Image ── */}
          <div className="w-full lg:w-2/5 order-1 lg:order-2 self-stretch">
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover object-center"
              style={{
                maxHeight: '460px',
                /* Fade out bottom on desktop to blend with white bg */
                WebkitMaskImage:
                  'linear-gradient(to bottom, black 60%, transparent 100%)',
                maskImage:
                  'linear-gradient(to bottom, black 60%, transparent 100%)',
              }}
            />
          </div>

        </div>
      {/* </div> */}
    </section>
  );
};

export default SymptomChecker;